// extracted by mini-css-extract-plugin
export default {"description":"AccountantExportModal_description__95mVw"};